export default __webpack_public_path__ + "static/media/4.ef34d5c7.jpg";